export const blockIconsFileFolderOpen = (
	<span className='material-symbols-outlined'>folder_open</span>
);
